
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { assignUserSalesUnitRecord } from "redux/authorization/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { getActiveSalesUnits } from "redux/crm/salesUnitSlice";
import React, { useEffect, useMemo, useState } from "react";
import Select from 'react-select';
import PropTypes from 'prop-types';
import { FaInfoCircle, FaStore } from "react-icons/fa";
import { selectIconComponents, reactSelectCompactStyles } from 'helpers/reactSelectIconControl';

// Stable reference — see note in AssignRole; inline components break the menu.
const SALES_UNIT_SELECT_COMPONENTS = selectIconComponents(<FaStore size={14} className="tw-text-emerald-500" />);

const RecordLevelSalesUnit = ({userId, data=[]}) => {
  const [selectedSalesUnits, setSelectedSalesUnits] = useState([]);

  const { handleSubmit, setValue } = useForm();
  const dispatch = useDispatch();

  const {activeSalesUnitsData} = useSelector((state) => state.crm_sales_unit);

  useEffect(() => {
    dispatch(getActiveSalesUnits());
  }, [dispatch]);


  useEffect(() => {
    const selected = data.length > 0 && data.map(item => ({value: item.id, label: item.name}));
    setSelectedSalesUnits(selected);
  }, [userId, data])

  const onSubmit = (data) => {

    try {
      if (userId) {
        dispatch(assignUserSalesUnitRecord({userId, data}))
      }
    }
    catch (error) {
      toast.error(error.message)
    }
  }
  
  const salesUnitOptions = activeSalesUnitsData && activeSalesUnitsData.map(item => ({value: item.id, label: `${item.name}-${item.description}`}));

  const defaultSalesUnitOption = useMemo(() => {
    if (data && data.length > 0) {
      return data.map((item) => ({value: item.id, label: item.full_name}));
    }
    return null;
  }, [data]);

  const handleChangeSalesUnit = (selectedOptions) => {
    const selectedOptionsValues = selectedOptions.map((option) => option.value);
    setValue('sales_unit_ids', selectedOptionsValues, { shouldValidate: true })
    setSelectedSalesUnits(selectedOptions)
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="tw-mb-2 tw-text-xs">
          <Select
            components={SALES_UNIT_SELECT_COMPONENTS}
            styles={reactSelectCompactStyles}
            closeMenuOnSelect={false}
            options={salesUnitOptions}
            defaultValue={defaultSalesUnitOption}
            value={selectedSalesUnits}
            placeholder='Select...'
            classNamePrefix='react-select'
            isMulti
            onChange={handleChangeSalesUnit}
          />
        </div>

        <div className="tw-flex tw-justify-end tw-mt-2">
          <button type="submit" className="tw-inline-flex tw-items-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-rounded-md tw-border tw-border-gray-300 tw-bg-white hover:tw-bg-gray-50 tw-text-gray-700 tw-cursor-pointer tw-transition-colors">
            {data.length > 0 ? "Update" : "Add"} Sales Unit
          </button>
        </div>
      </form>

      <div className="tw-mt-4 tw-text-xs"><FaInfoCircle /> Assigning Sales Unit for limit record access to the CRM system.</div>
    </>
  )
};

RecordLevelSalesUnit.propTypes = {
  userId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired
}

export default RecordLevelSalesUnit;